import { render, staticRenderFns } from "./Board.vue?vue&type=template&id=1563269b&scoped=true&"
import script from "./Board.vue?vue&type=script&lang=ts&"
export * from "./Board.vue?vue&type=script&lang=ts&"
import style0 from "./Board.vue?vue&type=style&index=0&id=1563269b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1563269b",
  null
  
)

export default component.exports